import React from "react"

import { latest as API_URL } from "../config/api";
import {  isSelected, isChecked, reservas, business_units, number_format } from "../config/Helpers";
import ListDynamic from "../reports/ListDynamic";
import ListStatics from "../reports/ListStatics";
import axios from "axios";


const postUrlDimensions  = API_URL + "dimensions";

class SidebarLeft extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            items : {
                brand       : "inactive",
                region      : "inactive",
                resort      : "inactive",
                business    : "inactive",
                reserve     : "inactive",
                plan        : "inactive",
                tariff      : "inactive",
                room        : "inactive",
                segment     : "inactive",
                type_room   : "inactive",
                type_tariff : "inactive",
                channel     : "inactive",
                agency      : "inactive",
                market      : "inactive"
            },
            sidebar_loading : " ",
            current_side            : "",
            brands_filter           : [],
            region_filter           : [],
            resort_filter           : [],
            business_line_filter    : [],
            channels_filter         : [],
            segments_filter         : [],
            plan_filter             : [],
            type_room_filter        : [],
            type_tariff_filter      : [],
            type_reserve_filter     : [],
            agencies_filter         : [],
            markets_filter          : [],
            business_units_filter   : [],
            sidebar_active          : "inactive-sidebar",
            channels_by_sgm         : [],
            channels_by_sgm_aux     : [],
            rooms_by_property       : [],
            rooms_by_property_aux   : [],
            segments                : [],
            properties              : [],
            filter_value_segment    : "",
            filter_value_property    : ""
        };
        this.isCheckedSegment = this.isCheckedSegment.bind(this)
        this.getChannels = this.getChannels.bind(this)
        this.getRooms = this.getRooms.bind(this)
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.getFilters = this.getFilters.bind(this)
        this.getResetValues = this.getResetValues.bind(this);
    }
    
    getDefaultValues(){
        return {
            channels_by_sgm: [],
            rooms_by_property : [],
            segments: [],
            properties : []
        };
    }
    getResetValues(){
        return {
            items : {
                brand       : "inactive",
                region      : "inactive",
                resort      : "inactive",
                business    : "inactive",
                reserve     : "inactive",
                plan        : "inactive",
                tariff      : "inactive",
                room        : "inactive",
                segment     : "inactive",
                type_room   : "inactive",
                type_tariff : "inactive",
                channel     : "inactive",
                agency      : "inactive",
                market      : "inactive"
            },
            sidebar_loading : " ",
            current_side            : "",
            brands_filter           : [],
            region_filter           : [],
            resort_filter           : [],
            business_line_filter    : [],
            channels_filter         : [],
            segments_filter         : [],
            plan_filter             : [],
            type_room_filter        : [],
            type_tariff_filter      : [],
            type_reserve_filter     : [],
            agencies_filter         : [],
            markets_filter          : [],
            business_units_filter   : [],
            sidebar_active          : "inactive-sidebar",
            channels_by_sgm         : [],
            channels_by_sgm_aux     : [],
            rooms_by_property       : [],
            rooms_by_property_aux   : [],
            segments                : [],
            properties              : [],
            filter_value_segment    : "",
            filter_value_property    : ""
        }
    }
    getFilters(){
        let self = this;
        var qs = require("qs");
        self.setState({
            sidebar_loading : " "
        }, function(){
            axios.post(postUrlDimensions, qs.stringify(self.props.app.currentFilters({ type : "sidebar" })))
            .then(function (response){ 
                self.setState({ 
                    brands_filter : response.data["brand"],
                    region_filter : response.data["region"],
                    resort_filter : response.data["property"],
                    business_line_filter : response.data["business-line"],
                    segments_filter : response.data["segments"],
                    channels_filter : response.data["channels"],
                    type_room_filter : response.data["room_type"],
                    type_tariff_filter : response.data["tariff_type"],
                    agencies_filter : response.data["agency"],
                    markets_filter : response.data["market"],
                    plan_filter : response.data["plan"],
                    type_reserve_filter : response.data["type_reserve"],
                    channels_filter_aux : response.data["channels"],
                    brands_filter_aux : response.data["brand"],
                    region_filter_aux : response.data["region"],
                    resort_filter_aux : response.data["property"],
                    business_line_filter_aux : response.data["business-line"],
                    segments_filter_aux : response.data["segments"],
                    type_reserve_filter_aux : response.data["type_reserve"],
                    type_room_filter_aux : response.data["room_type"],
                    type_tariff_filter_aux : response.data["tariff_type"],
                    agencies_filter_aux : response.data["agency"],
                    markets_filter_aux : response.data["market"],
                    plan_filter_aux : response.data["plan"],
                    mount : true,
                    sidebar_loading : " hide"
                }) 
            })
        })
    }

    handleClickModal(type){
        this.props.reportModelState(type)
    }
    isCheckedSegment(){
        let result          = false;
        let self           = this;
        let count_channels  = Object.keys(this.props.current_filter_channel).length - 1;
        let segments        = [];
        if(count_channels > -1){
            Object.keys(this.props.current_filter_channel).map(function(key, index){
                let key_segment = key.split("-")[1];
                if(segments[key_segment] === undefined){
                    segments[key_segment] = key_segment
                }
                if(count_channels === index){
                    Object.keys(segments).map(function(elem){
                        self.setState({ segments : segments });
                    })
                }
            })
        }else{
            self.setState({segments : [] });
        }
        
        return result;
    }

    filterDimensionByText(ref_state, event){
        let filter = event.target.value;
        if(ref_state !== "segments_filter" && ref_state !== "resort_filter"){
            this.setState({
                [ref_state] : this.state[ref_state + "_aux"]
            }, function(){
                let array_elements = this.state[ref_state].filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                if(filter === ""){
                    this.setState({
                        [ref_state] : this.state[ref_state + "_aux"]
                    })
                }else{
                    this.setState({
                        [ref_state] : array_elements
                    })
                }
            })
        }else if(ref_state === "segments_filter"){
            this.setState({
                [ref_state] : this.state[ref_state + "_aux"],
                channels_filter : this.state.channels_filter_aux
            }, function(){
                let array_segments = this.state[ref_state].filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                let array_channels = this.state.channels_filter.filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                if(filter === ""){
                    this.setState({
                        [ref_state] : this.state[ref_state + "_aux"],
                        channels_filter : this.state.channels_filter_aux,
                        filter_value_segment : ""
                    })
                }else{
                    this.setState({
                        [ref_state] : array_segments,
                        channels_filter : array_channels,
                        filter_value_segment : true
                    })
                }
                
            })
        }else if(ref_state === "resort_filter"){
            this.setState({
                [ref_state] : this.state[ref_state + "_aux"],
                type_room_filter : this.state.type_room_filter_aux
            }, function(){
                let array_properties = this.state[ref_state].filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                let array_rooms = this.state.type_room_filter.filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                if(filter === ""){
                
                    this.setState({
                        [ref_state] : this.state[ref_state + "_aux"],
                        type_room_filter : this.state.type_room_filter_aux,
                        filter_value_property : ""
                    })
                }else{
                    this.setState({
                        [ref_state] : array_properties,
                        type_room_filter : array_rooms,
                        filter_value_property : true
                    })
                }
                
            })
        }
    }
    handleClickSidebar(sidebar) {
        let self = this;
        let state_sidebar;
        const is_report = (sidebar === "models" || sidebar === "reports") ? " is-report" : "";
        this.setState(function(prev){
            if(prev.sidebar_active === "active-sidebar" + is_report && prev.current_side === sidebar){
                state_sidebar = "inactive-sidebar";
                sidebar       = "";
            }else{
                state_sidebar = "active-sidebar" + is_report;
                //this.getFilters();
            }
            return {
                sidebar_active : state_sidebar, 
                current_side : sidebar 
            }
        }, () => {
            this.props.activeSidebar(state_sidebar)
        }); 
    }
    handleClickMenuItem(item, type){
        let array_elements, self = this;
        if(type === "property"){
            array_elements  = self.props.current_filter_properties
        }else if(type === "region"){
            array_elements  = self.props.current_filter_region
        }else if(type === "reserve"){
            array_elements  = self.props.current_filter_reserve
        }else if(type === "business"){
            array_elements  = self.props.current_filter_business
        }else if(type === "brand"){
            array_elements  = self.props.current_filter_brand
        }else if(type === "plan"){
            array_elements  = self.props.current_filter_plan
        }else if(type === "segment"){
            array_elements  = self.props.current_filter_segment
        }else if(type === "channel"){
            array_elements  = self.props.current_filter_channel
        }else if(type === "type_room"){
            array_elements  = self.props.current_filter_type_room
        }else if(type === "type_tariff"){
            array_elements  = self.props.current_filter_type_tariff
        }else if(type === "agency"){
            array_elements  = self.props.current_filter_agency
        }else if(type === "market"){
            array_elements  = self.props.current_filter_market
        }
        if(type !== "segment"){
            if(array_elements[item.value] === undefined)
            {
                self.props.setFilterBubble(item.text, item.value, "hide", type)
            }else{
                self.props.setFiltersComponent(type, item.value)
            }
        }else if(type === "segment"){
            let group_elements  = this.props.app.state.current_filter_channel;

            if(this.state.segments[item.value] === undefined)
            {
                self.state.channels_by_sgm[item.value].map(function(item_channel, index){
                    group_elements[item_channel._id + "-" + item.value]  = { "channel" : item_channel.name, "value" : item_channel._id + "-" + item.value }
                });
                self.props.setFilterBubble("", "", "hide", "channel", group_elements)
            }else{
                self.state.channels_by_sgm[item.value].map(function(item_channel, index){
                    delete group_elements[item_channel._id + "-" + item.value];
                });
                self.props.setFiltersComponent("channel", "", group_elements)
            }
        }
    } 
    handleClickItemSidebar(item) {
        let self       = this;
        let new_state   = {};
        Object.keys(self.state.items).map(function(key){
            if(key === item){
                new_state[key]  = self.state.items[key] === "active" ? "inactive" : "active";
            }else{
                new_state[key]  = "inactive"
            }
        });

        self.setState({
            items : new_state
        })
    }
    getChannels(item_aux){
        let self = this;
        let id_major = item_aux._id;
        self.state.channels_by_sgm[id_major] = item_aux.channels;
        self.state.channels_by_sgm_aux[id_major] = item_aux.channels;
        if(item_aux.channels !== undefined){
            return item_aux.channels.map((item, index) =>
                <li  key={"list-channels-aux-"+index} onClick={self.handleClickMenuItem.bind(self, { text: item.name, value: item._id + "-" + id_major }, "channel")}>
                    <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/></span>
                    <input type="checkbox" 
                        checked={isChecked(self.props.current_filter_channel, item._id + "-" + id_major)} 
                        value={ item._id }  
                    />
                    <span className="checkmark"></span>
                </li>
            )
        }
    }
    getRooms(item_aux){
        let self           = this;
        let id_major        = item_aux.name;
        self.state.rooms_by_property[id_major] = item_aux.rooms;
        self.state.rooms_by_property_aux[id_major] = item_aux.rooms;
        if(item_aux.rooms !== undefined){
            return item_aux.rooms.map((item, index) =>
                <li  key={"list-channels-aux-"+index} onClick={self.handleClickMenuItem.bind(self, { text: item.name, value: item._id + "||" + id_major }, "type_room")}>
                    <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/></span>
                    <input type="checkbox" 
                        checked={isChecked(self.props.current_filter_type_room, item._id + "||" + id_major)} 
                        value={ item._id }  
                    />
                    <span className="checkmark"></span>
                </li>
            )
        }
    }
    render(){
        let self = this;
        const filterBrands = this.state.brands_filter === undefined ? "" : this.state.brands_filter.map(function(item, index){
            return (<li key={"filter-brand-"+index} onClick={self.handleClickMenuItem.bind(self, { text: item.name, value: item._id }, "brand")} >
                <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox" 
                        value={ index } 
                        checked={isChecked(self.props.current_filter_brand, item._id)} 
                    />
                    <span className="checkmark"></span>
                </span>
            </li>)
        });

        const filterRegion = this.state.region_filter === undefined ? "" : this.state.region_filter.map((item, index) =>
            <li key={"filter-region-"+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "region")}>
                <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox"
                        checked={isChecked(this.props.current_filter_region, item._id)} 
                        value={ item._id } 
                    />
                    <span className="checkmark"></span>
                </span>
            </li>
        );

        const filterBusiness = this.state.business_line_filter.map((item, index) =>
            <li key={"filter-business-"+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "business")}>
                <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox" 
                        checked={isChecked(this.props.current_filter_business, item._id)} 
                        value={ item._id } 
                    />
                    <span className="checkmark"></span>
                </span>
            </li>
        );
        const filterResort = this.state.resort_filter.map((item, index) =>
            <li key={"filter-resort-"+index}>
                <span className="title-list" onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "property")}>{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox" 
                        checked={isChecked(this.props.current_filter_properties, item._id)}
                    />
                    <span className="checkmark"></span>
                </span>
                <ul>
                    { this.state.filter_value_property === "" ? self.getRooms(item) : ""}
                </ul>
            </li>
        );
        console.log(this.state.segments_filter)
        console.log(this.state.segments)
        const filterSegments = this.state.segments_filter.map((item, index) =>
            <li key={"filter-segment-"+index}>
                <span className="title-list" onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "segment")}>{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox"
                        checked={this.state.segments[item._id] !== undefined ? true : false} 
                        value={ item._id }
                        ref={item._id} 
                        onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "segment")}
                    />
                    <span className="checkmark"></span>
                </span>
                <ul>
                    { this.state.filter_value_segment === "" ? self.getChannels(item) : ""}
                </ul>
            </li>
        );

        const filterReserve = this.state.type_reserve_filter.map((item, index) =>
            <li key={"filter-reserve-sidebar" + index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "reserve")}>
                <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox" 
                        checked={isChecked(this.props.current_filter_reserve, item._id)} 
                        value={ item._id } 
                        
                    />
                    <span className="checkmark"></span>
                </span>
            </li>
        );

        const filterPlan = this.state.plan_filter.map((item, index) =>
            <li key={"filter-plan-"+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "plan")}>
                <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox"
                        checked={isChecked(this.props.current_filter_plan, item._id)} 
                        value={ item._id } 
                        
                    />
                    <span className="checkmark"></span>
                </span>
            </li>
        );

        const filterChannels = this.state.channels_filter === undefined ? "" : Object.keys(this.state.channels_filter).map((item, index) => ( 
            <li key={"list-channels-aux-"+index} onClick={self.handleClickMenuItem.bind(self, { text: self.state.channels_filter[item].name, value: self.state.channels_filter[item]._id + "-" + self.state.channels_filter[item].id_major_segment }, "channel")}>
                <span className="title-list">{ self.state.channels_filter[item].name } <span className="total-by-filter" children={`(${number_format(self.state.channels_filter[item].total,0)})`}/>
                    <input type="checkbox" 
                        checked={isChecked(self.props.current_filter_channel, self.state.channels_filter[item]._id + "-" + self.state.channels_filter[item].id_major_segment)} 
                        value={ self.state.channels_filter[item]._id }  
                    />
                    <span className="checkmark"></span>
                </span>
            </li> 
        ));

        const filterTypeRoom = this.state.type_room_filter === undefined ? "" : this.state.type_room_filter.map((item, index) =>
            <li key={"filter-type-"+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "type_room")}>
                <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox"  
                        checked={isChecked(this.props.current_filter_type_room, item._id)} 
                        value={ item._id } 
                    
                    />
                    <span className="checkmark"></span>
                </span>
            </li>
        );

        const filterTypeTariff = this.state.type_tariff_filter === undefined ? "" : this.state.type_tariff_filter.map((item, index) =>
            <li key={"filter-type-tariff-"+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "type_tariff")}>
                <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox"  
                        checked={isChecked(this.props.current_filter_type_tariff, item._id)} 
                        value={ item._id } 
                    
                    />
                    <span className="checkmark"></span>
                </span>
            </li>
        );
        

        const filterMarkets = this.state.markets_filter === undefined ? "" : this.state.markets_filter.map((item, index) =>
            <li  key={"filter-market-"+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, "market")}>
                <span className="title-list">{ item.name } <span className="total-by-filter" children={`(${number_format(item.total,0)})`}/>
                    <input type="checkbox" 
                        checked={isChecked(this.props.current_filter_market, item._id)} 
                        value={ item._id }
                    />
                    <span className="checkmark"></span>
                </span>
            </li>
        );

    return(
        <section id="container-sidebar" className={"sidebar-left " + this.state.sidebar_active + " " + this.props.secondary_filter_bar}>
            <div className={"filters-section"}>
                <div className={"loading-sidebar " + this.state.sidebar_loading}>
                    <span>LOADING...</span>
                </div>
                <div onClick={this.handleClickSidebar.bind(this, "dimensions")}>
                    <a className="dimensions"><i className="fa fa-filter" aria-hidden="true"></i></a>
                    <span>FILTERS</span>
                    <span className={"close-wdg " + (this.state.current_side === "dimensions" ? "show" : "hide")}>X</span>
                </div>
                <ul className={ this.state.current_side === "dimensions" ? "active" : "" }>
                    <li className={this.state.items.business}>
                        <span onClick={this.handleClickItemSidebar.bind(this, "business")}>Business Unit</span>
                        <div className="sub-list">
                            <div className="">
                                <input 
                                    type="text" 
                                    onChange={this.filterDimensionByText.bind(this, "business_line_filter")}  
                                    placeholder="Search..."
                                />
                            </div>
                            <ul>
                                { filterBusiness }
                            </ul>
                        </div>
                    </li>
                    <li className={this.state.items.brand}>
                        <span onClick={this.handleClickItemSidebar.bind(this, "brand")}>Brand/Group</span>
                        <div className="sub-list">
                            <div className="">
                                <input 
                                    type="text" 
                                    onChange={this.filterDimensionByText.bind(this, "brands_filter")}  
                                    placeholder="Search..."
                                />
                            </div>
                            <ul>
                                { filterBrands }
                            </ul>
                        </div>
                    </li>
                    <li className={this.state.items.resort}>
                        <span onClick={this.handleClickItemSidebar.bind(this, "resort")}>Properties/Service</span>
                        <div className="sub-list">
                            <div className="">
                                <input 
                                    type="text" 
                                    onChange={this.filterDimensionByText.bind(this, "resort_filter")}  
                                    placeholder="Search..."
                                />
                            </div>
                            <ul>
                                { filterResort }
                                { this.state.filter_value_property !== "" ? filterTypeRoom : "" }
                            </ul>
                        </div>
                    </li>
                    <li className={this.state.items.region}>
                        <span onClick={this.handleClickItemSidebar.bind(this, "region")}>Region</span>
                        <div className="sub-list">
                            <div className="">
                                <input 
                                    type="text" 
                                    onChange={this.filterDimensionByText.bind(this, "region_filter")} 
                                    placeholder="Search..."
                                />
                            </div>
                            <ul>
                                { filterRegion }
                            </ul>
                        </div>
                    </li>
                    
                    <li className={this.state.items.reserve}>
                        <span onClick={this.handleClickItemSidebar.bind(this, "reserve")}>Reservation status</span>
                        <div className="sub-list">
                            <ul>
                                { filterReserve }
                            </ul>
                        </div>
                    </li>
                    <li className={this.state.items.plan}>
                        <span onClick={this.handleClickItemSidebar.bind(this, "plan")}>Plan type</span>
                        <div className="sub-list">
                            
                            <ul>
                                { filterPlan }
                            </ul>
                        </div>
                    </li>

                    <li className={this.state.items.segment}>
                        <span onClick={this.handleClickItemSidebar.bind(this, "segment")}>Segment/Agency</span>
                        <div className="sub-list">
                            <div className="">
                                <input 
                                    type="text" 
                                    onChange={this.filterDimensionByText.bind(this, "segments_filter")}  
                                    placeholder="Search..."
                                />
                            </div>
                            <ul>
                                { filterSegments }
                                { this.state.filter_value_segment !== "" ? filterChannels : "" }
                            </ul>
                        </div>
                    </li> 
                   {/* <li className={this.state.items.type_tariff}>
                        <span onClick={this.handleClickItemSidebar.bind(this, "type_tariff")}>Tipo de tarifa</span>
                        <div className="sub-list">
                            <div className="">
                                <input 
                                    type="text" 
                                    onChange={this.filterDimensionByText.bind(this, "type_tariff_filter")}  
                                    placeholder="Search..."
                                />
                            </div>
                            <ul>
                                { filterTypeTariff }
                            </ul>
                        </div>
                    </li> */ }

                    <li className={this.state.items.market}>
                        <span onClick={this.handleClickItemSidebar.bind(this, "market")}>Market</span>
                        <div className="sub-list">
                            <div>
                                <input 
                                    type="text" 
                                    onChange={this.filterDimensionByText.bind(this, "markets_filter")}
                                    placeholder="Search..."  
                                />
                            </div>
                            <ul>
                                { filterMarkets }
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>

            { /*<div>
                <a className="expressions" onClick={this.handleClickSidebar.bind(this)}> <i className="fa fa-list-alt" aria-hidden="true"></i> </a>
                <span>EXPRESIONES</span>
            </div> */ }
            <div className={ (this.state.current_side === "reports" ? "active" : "") }>
                <div onClick={this.handleClickSidebar.bind(this, "reports")}>
                    <a className="reports"> <i className="fa fa-clipboard" aria-hidden="true"></i> </a>
                    <span>FIXED REPORTS</span>
                    <span className={"close-wdg " + (this.state.current_side === "reports" ? "show" : "hide")}>X</span>
                </div>
                <ListStatics 
                    status={(this.state.current_side === "reports" ? "active" : "")}
                />
            </div>
            <div className={ (this.state.current_side === "models" ? "active" : "") }>
                <div onClick={this.handleClickSidebar.bind(this, "models")}>
                    <a className="models"> <i className="fa fa-clipboard" aria-hidden="true"></i> </a>
                    <span>DYNAMIC REPORTS</span>
                    <span className={"close-wdg " + (this.state.current_side === "models" ? "show" : "hide")}>X</span>
                </div>
                <ListDynamic 
                    status={(this.state.current_side === "models" ? "active" : "")}
                />
            </div>
            <div>
                <div  onClick={this.handleClickModal.bind(this, "reports-new")}>
                    <a className="models"> <i className="fa fa-save" aria-hidden="true"></i> </a>
                    <span>NEW REPORT</span>
                </div>
            </div>
            <div className="with-love">
                <div>
                    <span>Made with <i className="fa fa-heart"></i> by Axovia</span>
                </div>
            </div>
        </section>
    )}
}

export default SidebarLeft


// WEBPACK FOOTER //
// ./src/Frontend/components/SidebarLeft.js